import { render, staticRenderFns } from "./productData.vue?vue&type=template&id=39f18b96&scoped=true"
import script from "./productData.vue?vue&type=script&lang=js"
export * from "./productData.vue?vue&type=script&lang=js"
import style0 from "./productData.vue?vue&type=style&index=0&id=39f18b96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39f18b96",
  null
  
)

export default component.exports